import { Variant } from 'types/entity/product';

// Type predicates so a truthy result also narrows away undefined for callers passing e.g. `Variant | undefined`.
export function isVariantMatching(variant?: Variant): variant is Variant {
  return variant?.isMatchingVariant === true;
}

export function isVariantOnStock(variant?: Variant): variant is Variant {
  return variant?.isOnStock === true;
}

// A type predicate so callers accessing variant.price.centAmount afterwards don't need a separate optional check.
export function hasVariantPrice(
  variant?: Variant,
): variant is Variant & { price: NonNullable<Variant['price']> & { centAmount: number } } {
  return variant?.price?.centAmount !== undefined;
}

export function isVariantEligible(
  variant?: Variant,
): variant is Variant & { price: NonNullable<Variant['price']> & { centAmount: number } } {
  return isVariantMatching(variant) && isVariantOnStock(variant) && hasVariantPrice(variant);
}
